import React, {useEffect, useState} from 'react';
import './CustomerInstallmentsDetail.scss';
import {CloseSVG} from "../ExportSVG";
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaInput from "../../DynaView/DynaInput";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import DynaButton from "../../DynaView/DynaButton";
import {useNavigate} from "react-router-dom";

const CustomerInstallmentsDetail = ({detailData, setStep, setDetailData}) => {

  const navigateTo = useNavigate();
  const [sendData, setSendData] = useState({
    paymentType: "default",
    bankId: "",
    totalPay: "0"
  })
  const [bankList, setBankList] = useState([]);
  const [componentData, setComponentData] = useState({
    data: [],
    maxPrice: 0
  })

  const BankAndAgentList = async () => {
    const response = await _axios.get(prefixUrl() + "/insurance/?request=bankList");
    if (response.data.status) {
      setBankList(response.data.data)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void BankAndAgentList()
    let price = 0
    detailData?.data?.forEach((item) => {
      price = price + parseFloat(item.remaining);
    })
    setComponentData({data: detailData?.data, maxPrice: price})
  }, []);

  const deleteDetailData = () => {
    setDetailData({
      tableRow: {},
      data: []
    })
    setStep(1)
  }

  useEffect(() => {
    if (componentData?.data?.length > 0) {
      let price = +sendData?.totalPay
      let temp = [...componentData?.data]
      temp.forEach(item => {
        if (+price > item.installmentPrice) {
          item.payedPrice = +item.installmentPrice;
        } else {
          item.payedPrice = +price;
        }
        if (+price > +item.installmentPrice) {
          item.remaining = 0
        } else {
          item.remaining = +item.installmentPrice - price;
        }
        price = +price - +item.installmentPrice;
        if (price < 0) {
          price = 0
        }
      })
      setComponentData({...componentData, data: temp})
    }
  }, [sendData?.totalPay]);

  const formDataHandler = async () => {
    if (+sendData?.totalPay === 0) {
      return toast.error("مبلغ واریزی را وارد کنید")
    }

    if (sendData?.paymentType === "bank" && sendData?.bankId === "") {
      return toast.error("حساب بانکی را انتخاب کنید")
    }

    let temp = []
    componentData.data.forEach((item) => {
      if (+item?.payedPrice !== 0) {
        temp.push({id: item.id, payedPrice: item.payedPrice})
      }
    })
    const Data = {
      request: "payCustomerInstallment",
      data: {
        paymentType: sendData?.paymentType,
        bankId: sendData?.bankId,
        payments: temp,
      }
    }
    const response = await _axios.post(prefixUrl() + "/insurance/", Data)
    if (response?.data.status) {
      toast.success(response.data?.message)
      setStep(1)
    } else {
      toast.error(response?.data?.message)
    }
  }

  try {
    return (
      <div className="CustomerInstallmentsDetail">
        <ul className={"show-row"}>
          <li className={"header-class"}>
            <div style={{width: "5%"}}>ردیف</div>
            <div style={{width: "15%"}}>کد ملی</div>
            <div style={{width: "15%"}}>نوع بیمه نامه</div>
            <div style={{width: "20%"}}>شماره بیمه نامه</div>
            <div style={{width: "20%"}}>نام مشتری</div>
            <div style={{width: "20%"}}>عنوان سازمان</div>
            <div style={{width: "5%"}}>عملیات</div>
          </li>
          <li>
            <div style={{width: "5%"}}>1</div>
            <div style={{width: "15%"}}>{detailData?.tableRow?.nationalId}</div>
            <div style={{width: "15%"}}>{detailData?.tableRow?.insuranceType}</div>
            <div style={{width: "20%"}}>{detailData?.tableRow?.insuranceNumber}</div>
            <div style={{width: "20%"}}>{detailData?.tableRow?.personName}</div>
            <div style={{width: "20%"}}>{detailData?.tableRow?.organizationName}</div>
            <div style={{width: "5%", cursor: 'pointer'}} onClick={deleteDetailData}><CloseSVG/></div>
          </li>
        </ul>

        <div className="radio-buttons-container">
          <div className="radio-button">
            <label htmlFor="radio1" className="radio-button__label" style={{padding: "0", fontWeight: "500"}}>
              نوع پرداخت مشتری :
            </label>
          </div>

          <div className="radio-button">
            <input name="radio-group1"
                   id="radio2"
                   className="radio-button__input"
                   type="radio"
                   checked={sendData?.paymentType === "default"}
                   onChange={() => setSendData({...sendData, paymentType: "default"})}/>
            <label htmlFor="radio2" className="radio-button__label">
              <span className="radio-button__custom"></span>
              مستقیم توسط مشتری به حساب بیمه </label>
          </div>

          <div className="radio-button">
            <input name="radio-group1"
                   id="radio1"
                   className="radio-button__input"
                   type="radio"
                   checked={sendData?.paymentType === "bank"}
                   onChange={() => setSendData({...sendData, paymentType: "bank"})}/>
            <label htmlFor="radio1" className="radio-button__label">
              <span className="radio-button__custom"></span>
              به حساب نماینده
            </label>
          </div>

        </div>

        <div className={"form-side"}>
          <DynaInput label={"مبلغ واریزی"}
                     name={"totalPay"}
                     className={"solid-dyna-input"}
                     placeholder={"مبلغ واریزی را وارد کنید"}
                     hasComma={true}
                     value={UtilsFunctions.addCommas(sendData?.totalPay)}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       if (+data?.totalPay <= componentData?.maxPrice) {
                         setSendData({...sendData, ...data})
                       }
                     }}
          />

          {sendData?.paymentType === "bank" &&
            <DynaSelectBox options={bankList}
                           hasFilter={true}
                           label={"انتخاب بانک"}
                           className={"solid-dyna-input"}
                           value={sendData?.bankId}
                           onChange={(data) => setSendData({...sendData, bankId: data.value})}/>
          }
        </div>

        <ul className={"list-side"}>
          {componentData?.data.map((item, index) => (
            <li key={"l" + index}>
              <h5>{"قسط " + item?.number}</h5>
              <div className={"inline-row"}>
                <h5>مبلغ قسط</h5>
                <h5>:</h5>
                <h5>{UtilsFunctions.addCommas(item?.installmentPrice)}</h5>
              </div>
              <div className={"inline-row"}>
                <h5>تاریخ</h5>
                <h5>:</h5>
                <h5>{item?.date}</h5>
              </div>
              <div className={"inline-row"}>
                <h5>مبلغ واریزی</h5>
                <h5>:</h5>
                <h5>{UtilsFunctions.addCommas(item?.payedPrice)}</h5>
              </div>
              <div className={"inline-row"}>
                <h5>مبلغ مانده</h5>
                <h5>:</h5>
                <h5>{UtilsFunctions.addCommas(+item?.remaining)}</h5>
              </div>
            </li>
          ))}
        </ul>

        <div className={"row-button"}>
          <DynaButton className={"insurance-button-cansel"}
                      type={"button"}
                      onClick={() => navigateTo(-1)}>انصراف</DynaButton>
          <DynaButton className={"insurance-button"}
                      type={"button"}
                      onClick={formDataHandler}>ثبت</DynaButton>
        </div>
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default CustomerInstallmentsDetail;